const cargoType = {
  Breakbulk: 'Cargaisons générales',
  Bulk: 'Vrac',
};

export default cargoType;
